import {sanityClient} from "./sanityClient";

export const servicesQuery = `
  *[_type == "service" && active == true]
  | order(sortOrder asc, title asc) {
    "slug": slug.current,
    title,
    tagline,
    eyebrow,
    description,
    "cardImage": coalesce(cardImage.asset->url, cardImageUrl),
    "heroImage": coalesce(heroImage.asset->url, heroImageUrl),
    "image": coalesce(image.asset->url, imageUrl, cardImage.asset->url, cardImageUrl),
    seo {
      title,
      description
    },
    benefits,
    useCases,
    bullets,
    sections[] {
      title,
      description,
      "image": coalesce(image.asset->url, imageUrl),
      items
    }
  }
`;

export async function getServices() {
  return sanityClient.fetch(servicesQuery);
}
